import React from 'react';
import { Home, Settings, User } from 'react-feather';
import { Link } from 'react-router-dom';

export default function Tabs() {
    return (
        <>
            <div className='container-fluid'>
                <div className='col-12'>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>تب ها</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/tabs'>تب ها</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className='space-20' />

                <div className='row'>
                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                تب معمولی
                            </div>

                            <div className='card-body'>
                                <nav>
                                    <div
                                        className='nav nav-tabs'
                                        id='nav-tab'
                                        role='tablist'
                                    >
                                        <button
                                            className='nav-link active'
                                            id='nav-home-tab'
                                            data-bs-toggle='tab'
                                            data-bs-target='#nav-home'
                                            type='button'
                                            role='tab'
                                            aria-controls='nav-home'
                                            aria-selected='true'
                                        >
                                            خانه
                                        </button>

                                        <button
                                            className='nav-link'
                                            id='nav-profile-tab'
                                            data-bs-toggle='tab'
                                            data-bs-target='#nav-profile'
                                            type='button'
                                            role='tab'
                                            aria-controls='nav-profile'
                                            aria-selected='false'
                                        >
                                            پروفایل
                                        </button>

                                        <button
                                            className='nav-link'
                                            id='nav-contact-tab'
                                            data-bs-toggle='tab'
                                            data-bs-target='#nav-contact'
                                            type='button'
                                            role='tab'
                                            aria-controls='nav-contact'
                                            aria-selected='false'
                                        >
                                            تنظیمات
                                        </button>
                                    </div>
                                </nav>

                                <div className='space-15' />

                                <div
                                    className='tab-content'
                                    id='nav-tabContent'
                                >
                                    <div
                                        className='tab-pane fade show active'
                                        id='nav-home'
                                        role='tabpanel'
                                        aria-labelledby='nav-home-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>

                                    <div
                                        className='tab-pane fade'
                                        id='nav-profile'
                                        role='tabpanel'
                                        aria-labelledby='nav-profile-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>

                                    <div
                                        className='tab-pane fade'
                                        id='nav-contact'
                                        role='tabpanel'
                                        aria-labelledby='nav-contact-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                تب دکمه ای
                            </div>

                            <div className='card-body'>
                                <ul
                                    className='nav nav-pills mb-3'
                                    id='pills-tab'
                                    role='tablist'
                                >
                                    <li
                                        className='nav-item'
                                        role='presentation'
                                    >
                                        <button
                                            className='nav-link active'
                                            id='pills-home-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#pills-home'
                                            type='button'
                                            role='tab'
                                            aria-controls='pills-home'
                                            aria-selected='true'
                                        >
                                            خانه
                                        </button>
                                    </li>

                                    <li
                                        className='nav-item'
                                        role='presentation'
                                    >
                                        <button
                                            className='nav-link'
                                            id='pills-profile-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#pills-profile'
                                            type='button'
                                            role='tab'
                                            aria-controls='pills-profile'
                                            aria-selected='false'
                                        >
                                            پروفایل
                                        </button>
                                    </li>

                                    <li
                                        className='nav-item'
                                        role='presentation'
                                    >
                                        <button
                                            className='nav-link'
                                            id='pills-contact-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#pills-contact'
                                            type='button'
                                            role='tab'
                                            aria-controls='pills-contact'
                                            aria-selected='false'
                                        >
                                            تنظیمات
                                        </button>
                                    </li>
                                </ul>
                                <div
                                    className='tab-content'
                                    id='pills-tabContent'
                                >
                                    <div
                                        className='tab-pane fade show active'
                                        id='pills-home'
                                        role='tabpanel'
                                        aria-labelledby='pills-home-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>

                                    <div
                                        className='tab-pane fade'
                                        id='pills-profile'
                                        role='tabpanel'
                                        aria-labelledby='pills-profile-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>

                                    <div
                                        className='tab-pane fade'
                                        id='pills-contact'
                                        role='tabpanel'
                                        aria-labelledby='pills-contact-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                تب افقی
                            </div>

                            <div className='card-body'>
                                <div className='d-flex align-items-start'>
                                    <div
                                        className='nav flex-column nav-pills ms-3'
                                        id='v-pills-tab'
                                        role='tablist'
                                        aria-orientation='vertical'
                                    >
                                        <button
                                            className='nav-link active'
                                            id='v-pills-home-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#v-pills-home'
                                            type='button'
                                            role='tab'
                                            aria-controls='v-pills-home'
                                            aria-selected='true'
                                        >
                                            خانه
                                        </button>

                                        <button
                                            className='nav-link'
                                            id='v-pills-profile-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#v-pills-profile'
                                            type='button'
                                            role='tab'
                                            aria-controls='v-pills-profile'
                                            aria-selected='false'
                                        >
                                            پروفایل
                                        </button>

                                        <button
                                            className='nav-link'
                                            id='v-pills-messages-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#v-pills-messages'
                                            type='button'
                                            role='tab'
                                            aria-controls='v-pills-messages'
                                            aria-selected='false'
                                        >
                                            پیام ها
                                        </button>

                                        <button
                                            className='nav-link'
                                            id='v-pills-settings-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#v-pills-settings'
                                            type='button'
                                            role='tab'
                                            aria-controls='v-pills-settings'
                                            aria-selected='false'
                                        >
                                            تنظیمات
                                        </button>
                                    </div>

                                    <div
                                        className='tab-content'
                                        id='v-pills-tabContent'
                                    >
                                        <div
                                            className='tab-pane fade show active'
                                            id='v-pills-home'
                                            role='tabpanel'
                                            aria-labelledby='v-pills-home-tab'
                                        >
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد.
                                        </div>

                                        <div
                                            className='tab-pane fade'
                                            id='v-pills-profile'
                                            role='tabpanel'
                                            aria-labelledby='v-pills-profile-tab'
                                        >
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد.
                                        </div>

                                        <div
                                            className='tab-pane fade'
                                            id='v-pills-messages'
                                            role='tabpanel'
                                            aria-labelledby='v-pills-messages-tab'
                                        >
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد.
                                        </div>

                                        <div
                                            className='tab-pane fade'
                                            id='v-pills-settings'
                                            role='tabpanel'
                                            aria-labelledby='v-pills-settings-tab'
                                        >
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                تب آیکون دار
                            </div>

                            <div className='card-body'>
                                <ul
                                    className='nav nav-pills mb-3'
                                    id='wide-tab'
                                    role='tablist'
                                >
                                    <li
                                        className='nav-item nav-wide'
                                        role='presentation'
                                    >
                                        <button
                                            className='nav-link w-100 active'
                                            id='wide-home-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#wide-home'
                                            type='button'
                                            role='tab'
                                            aria-controls='wide-home'
                                            aria-selected='true'
                                        >
                                            <Home />
                                        </button>
                                    </li>

                                    <li
                                        className='nav-item nav-wide'
                                        role='presentation'
                                    >
                                        <button
                                            className='nav-link w-100'
                                            id='wide-profile-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#wide-profile'
                                            type='button'
                                            role='tab'
                                            aria-controls='wide-profile'
                                            aria-selected='false'
                                        >
                                            <User />
                                        </button>
                                    </li>

                                    <li
                                        className='nav-item nav-wide'
                                        role='presentation'
                                    >
                                        <button
                                            className='nav-link w-100'
                                            id='wide-contact-tab'
                                            data-bs-toggle='pill'
                                            data-bs-target='#wide-contact'
                                            type='button'
                                            role='tab'
                                            aria-controls='wide-contact'
                                            aria-selected='false'
                                        >
                                            <Settings />
                                        </button>
                                    </li>
                                </ul>

                                <div
                                    className='tab-content'
                                    id='wide-tabContent'
                                >
                                    <div
                                        className='tab-pane fade show active'
                                        id='wide-home'
                                        role='tabpanel'
                                        aria-labelledby='wide-home-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>

                                    <div
                                        className='tab-pane fade'
                                        id='wide-profile'
                                        role='tabpanel'
                                        aria-labelledby='wide-profile-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>

                                    <div
                                        className='tab-pane fade'
                                        id='wide-contact'
                                        role='tabpanel'
                                        aria-labelledby='wide-contact-tab'
                                    >
                                        لورم ایپسوم متن ساختگی با تولید سادگی
                                        نامفهوم از صنعت چاپ، و با استفاده از
                                        طراحان گرافیک است، چاپگرها و متون بلکه
                                        روزنامه و مجله در ستون و سطرآنچنان که
                                        لازم است، و برای شرایط فعلی تکنولوژی
                                        مورد نیاز، و کاربردهای متنوع با هدف
                                        بهبود ابزارهای کاربردی می باشد، کتابهای
                                        زیادی در شصت و سه درصد گذشته حال و
                                        آینده، شناخت فراوان جامعه و متخصصان را
                                        می طلبد.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
